import { SortDescriptor } from '@progress/kendo-data-query';

export const viewInvoiceFilters: { filters: any[]; sort: SortDescriptor[] }[] = [
  {
    filters: [
      { field: 'status', value: 'Deleted', operator: 'neq' },
      { field: 'poStatus', value: 'Closed', operator: 'neq' },
    ],
    sort: [],
  },
  {
    filters: [],
    sort: [],
  },
  {
    filters: [
      {
        field: 'currentDocTotal',
        value: '0',
        operator: 'gte',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'currentDocTotal',
        value: '0',
        operator: 'lt',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'percentRecvByQuantity',
        value: '100',
        operator: 'lt',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'percentRecvByQuantity',
        value: '100',
        operator: 'gt',
      },
    ],
    sort: [
      {
        field: 'percentRecvByDollar',
        dir: 'desc',
      },
    ],
  },
  {
    filters: [{ field: 'Status', value: 'Complete', operator: 'contains' }],
    sort: [],
  },
  {
    filters: [{ field: 'Status', value: 'Deleted', operator: 'contains' }],
    sort: [],
  },
  {
    filters: [
      {
        field: 'canComplete',
        value: 'true',
        operator: 'eq',
      },
    ],
    sort: [],
  },
  {
    filters: [
      {
        field: 'canClosePo',
        value: 'true',
        operator: 'eq',
      },
    ],
    sort: [],
  },
  {
    filters: [{ field: 'numOfAttachments', value: '0', operator: 'gt' }],
    sort: [],
  },
  {
    filters: [{ field: 'numOfAttachments', value: '0', operator: 'eq' }],
    sort: [],
  },
  {
    filters: [
      { field: 'poStatus', value: 'Closed', operator: 'contains' },
      { field: 'Status', value: 'Complete', operator: 'contains' },
    ],
    sort: [],
  },
  {
    filters: [{ field: 'invoiceNumber', value: 'create new', operator: 'contains' }],
    sort: [],
  },
];
